/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
"use strict";

const Hook = require("./Hook");
const HookCodeFactory = require("./HookCodeFactory");
class AsyncSeriesHookCodeFactory extends HookCodeFactory {
  content(_ref) {
    let onError = _ref.onError,
      onDone = _ref.onDone;
    return this.callTapsSeries({
      onError: (i, err, next, doneBreak) => onError(err) + doneBreak(true),
      onDone
    });
  }
}
const factory = new AsyncSeriesHookCodeFactory();
class AsyncSeriesHook extends Hook {
  compile(options) {
    factory.setup(this, options);
    return factory.create(options);
  }
}
Object.defineProperties(AsyncSeriesHook.prototype, {
  _call: {
    value: undefined,
    configurable: true,
    writable: true
  }
});
module.exports = AsyncSeriesHook;